import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { mergeMap } from 'rxjs/operators';

import { DeviceNotesService } from '@rocksoft/mdm-sdk-v2';
import { NotesResolverActions, NotesApiActions, NotesUIActions } from './notes.actions';
import { safeMap } from '@era/stores';

@Injectable()
export class NotesEffects {
  constructor(
    private deviceNotesService: DeviceNotesService,
    private readonly actions$: Actions
  ) {}

  notesRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotesResolverActions.notesRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.deviceNotesService.getAllNotes(udid, 'Apple', '2.0'),
          (notes) => NotesApiActions.notesLoaded({ notes, udid }),
          (error) => NotesApiActions.notesLoadedError({ error })
        )
      )
    );
  });

  noteAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotesUIActions.noteAdded),
      mergeMap(({ note, udid }) =>
        safeMap(
          this.deviceNotesService.addNote('2.0', udid, 'Apple', { content: note.content }),
          (createdNote) => NotesApiActions.noteAdded({ note: createdNote, udid }),
          (error) => NotesApiActions.noteAddedError({ error })
        )
      )
    );
  });

  noteDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotesUIActions.noteDeleted),
      mergeMap(({ note, udid }) =>
        safeMap(
          this.deviceNotesService.deleteNote(note.id, 'Apple', udid, '2.0'),
          () => NotesApiActions.noteDeleted({ note, udid }),
          (error) => NotesApiActions.noteDeletedError({ error })
        )
      )
    );
  });
}
